import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import './HomeRight.css'; // Import the CSS file for styling

import newsletter from "./assets/newletter.png";
import globe from "./assets/globe.png";
import samoa from "./assets/samao.png";
import thailand from "./assets/thailand.png";
import micronesia from "./assets/micronesia.png";
import kiribati from "./assets/kiribati.png";
import guyana from "./assets/guyana.png";
import tonga from "./assets/tonga.png";
import jamaica from "./assets/jamaica.png";
import england from "./assets/england.png";
import antigua from "./assets/antigua.png";
import trinidad from "./assets/Trinidad.png";
import grenada from "./assets/grenada.png";
import philippine from "./assets/philippine.png";
import fiji from "./assets/fiji.png";
import chile from "./assets/chile.png";
import newzealand from "./assets/newzealand.png";
import durban from "./assets/durban.png";
import pakistan from "./assets/pakistan.png";
import australia from "./assets/australia.png";
import srilanka from "./assets/srilanka.png";
import southampton from "./assets/southampton.png";
import cyprus from "./assets/cyprus.jpg";
import saintvincent from "./assets/saint-vincent.png";
import barbados from "./assets/barbados.png";
import caymanisland from "./assets/cayman-island.png";
import saintlucia from "./assets/saint lucia.png";
import bahamas from "./assets/bahamas.png";
import tanzania from "./assets/tanzania.png";
import kenya from "./assets/kenya.png";
import uganda from "./assets/uganda.png";
import CreditCard from "./assets/credit-card-banner.jpeg";
import DoubleCab from "./assets/double-cab.png";
import HiluxChamp from "./assets/hilux-champ.png";

const countries = [
    { name: 'JAMAICA', logo: jamaica },
    { name: 'SAINT VINCENT AND GRENADINE', logo: saintvincent },
    { name: 'BARBADOS', logo: barbados },
    { name: 'GUYANA', logo: guyana },
    { name: 'PAKISTAN', logo: pakistan },
    { name: 'CAYMAN ISLAND', logo: caymanisland },
    { name: 'GRENADA', logo: grenada },
    { name: 'SAINT LUCIA', logo: saintlucia },
    { name: 'BAHAMAS', logo: bahamas },
    { name: 'TANZANIA', logo: tanzania },
    { name: 'KENYA', logo: kenya },
    { name: 'UGANDA', logo: uganda },
    { name: 'THAILAND', logo: thailand },
    { name: 'PHILIPPINE', logo: philippine },
    { name: 'UNITED KINGDOM', logo: england },
    { name: 'SAMOA', logo: samoa },
    { name: 'MICRONESIA', logo: micronesia },
    { name: 'KIRIBATI', logo: kiribati },
    { name: 'TONGA', logo: tonga },
    { name: 'FIJI', logo: fiji },
    { name: 'CHILE', logo: chile },
    { name: 'NEW ZEALAND', logo: newzealand },
    { name: 'DURBAN', logo: durban },
    { name: 'AUSTRALIA', logo: australia },
    { name: 'SRI LANKA', logo: srilanka },
    { name: 'UK SOUTHAMPTON', logo: southampton },
    { name: 'CYPRUS', logo: cyprus },
    { name: 'ANTIGUA AND BARBUDA', logo: antigua },
    { name: 'TRINIDAD AND TOBAGO', logo: trinidad },
];

const HomeRight = () => {
    const navigate = useNavigate(); // Initialize useNavigate

    // Handle country click and redirect to SearchIndividual with criteria=country
    const handleCountryClick = (countryName) => {
        console.log("Criteria: country, Value:", countryName); // Debugging
        navigate(`/search-individual?criteria=country&value=${encodeURIComponent(countryName)}`);
    };

    return (
        <>
            <div className="home-right">
                <div className="header">
                    <img src={CreditCard} alt="CreditCard" />
                    {/* <p>Newsletter</p>
                    <div className='bulletpoint'>
                        <ul>
                            <li><span></span>Now operating in your country</li>
                            <li><span></span>Signup up for 20% instant discount</li>
                            <li><span></span>Subscribe for latest updates</li>
                        </ul>
                    </div> */}
                    <img src={DoubleCab} alt="DoubleCab" />
                    <img src={HiluxChamp} alt="HiluxChamp" />
                </div>

                <div className="mi-container">
                    <div className="mi-header">
                        <h4>SAAD MOTORS (THAILAND) CO.,LTD</h4>
                    </div>
                    <ul className="mi-list">
                        {countries.map((country, index) => (
                            <li
                                key={index}
                                onClick={() => handleCountryClick(country.name)}
                                style={{ cursor: 'pointer' }} // Add pointer cursor for better UX
                            >
                                <img src={country.logo} alt={country.name} />
                                {country.name}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    );
};

export default HomeRight;